import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { PayWithButton } from "../../../common/PayWithButton";
import { CustomPhoneInput } from "../../../common/PhoneInput";

export const Details = ({
  onPay,
  defaultName,
  defaultPhone,
  defaultEmail,
  isLoading,
  emailError,
  setEmailError,
}: {
  onPay: () => void;
  defaultName: string;
  defaultPhone?: string;
  defaultEmail?: string;
  isLoading?: boolean;
  emailError?: string;
  setEmailError?: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const { handleSubmit, control, register } = useForm();
  const [fullName, setFullName] = useState(defaultName);
  const [email, setEmail] = useState(defaultEmail);
  const [phoneVal, setPhoneVal] = useState(defaultPhone);
  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onPay)}>
        <div className={styles.form}>
          <div className={styles.accNumInput}>
            <Input
              register={register}
              value={fullName}
              onChange={(e: any) => setFullName(e.target.value)}
              inputId="fullname"
              type="text"
              labelfocus="Full name"
              placeholder="Full name"
            />
          </div>
          <div className={styles.dualInput}>
            <Input
              register={register}
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
              inputId="email"
              labelfocus="Email address"
              placeholder="Email address"
              errorText={emailError}
              setErrorText={setEmailError}
            />

            <CustomPhoneInput
              register={register}
              inputId="phone"
              type="text"
              labelfocus="Phone number"
              placeholder="Phone number"
              control={control}
              value={phoneVal}
              setVal={setPhoneVal}
            />
          </div>
        </div>
        <ButtonFooter showNote>
          <PayWithButton
            isLoading={isLoading}
            isDisabled={
              !email?.length || !fullName?.length || !phoneVal?.length
            }
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
